import '../styles.scss'
import React from 'react'
import { TextNumberFormat } from 'components/Form'

const FieldTextNumberViewUI = ({ value, onChangeInner, fieldName }) => (
  <div style={{ width: '25%' }}>
    <div className='formGroupPrice'>
      <TextNumberFormat 
        defaultValue={isNaN(value) ? 0 : value }
        value={value}
        id={fieldName}
        name={fieldName}
        //onChange={value => onChange({ target: { name: fieldName, value: isNaN(value) ? 0 : value } })}
        onChange={onChangeInner}
        className={'new-input price plugin-payment__input'}
      />
      <span className='input-group-text wrapper-icon-euro-price'>
        <i className='fa fa-eur'></i>
      </span>
    </div>
  </div>
)

export default FieldTextNumberViewUI